import { isPredefinedMessageConfigContext } from "@fidget/common/models/shared/spinner/types/messageWidgets/WidgetFormSubmissionWithWidget";
import { IChatItem } from "./ChatItem";
import { ChatItemType } from "./ChatItemType";
import {
  IMeetingChatItem,
  INotificationChatItem,
  IUserEventChatItem,
  IMeetingEventChatItem,
  IMeetingSchedulerChatItem,
  ICallEventChatItem,
  ICobrowsingEventChatItem,
  IUserTextChatItem,
  IFakeUserTextChatItem,
  INoteChatItem,
  IStatusChangeChatItem,
  IDateSeparatorChatItem,
  IContactEnquiryChatItem,
  IEmptyChatItem,
  ICTAEventChatItem,
  IWidgetFormEventChatItem,
  ITagsChangeChatItem,
  ITopicsChangeChatItem,
  ChatItemGroup
} from "./items";
import { IRoomSummaryChatItem } from "./items/RoomSummaryChatItem";

export class ChatItemAssertion {
  static isGroup(chatItem: IChatItem): chatItem is ChatItemGroup {
    return chatItem.type === ChatItemType.Group;
  }

  static isNotification(chatItem: IChatItem): chatItem is INotificationChatItem {
    return chatItem.type === ChatItemType.Notification;
  }

  static isUserEvent(chatItem: IChatItem): chatItem is IUserEventChatItem {
    return chatItem.type === ChatItemType.UserEvent;
  }

  static isMeeting(chatItem: IChatItem): chatItem is IMeetingChatItem {
    return chatItem.type === ChatItemType.Meeting;
  }

  static isMeetingEvent(chatItem: IChatItem): chatItem is IMeetingEventChatItem {
    return chatItem.type === ChatItemType.MeetingEvent;
  }

  static isMeetingScheduler(chatItem: IChatItem): chatItem is IMeetingSchedulerChatItem {
    return chatItem.type === ChatItemType.MeetingScheduler;
  }

  static isCallEvent(chatItem: IChatItem): chatItem is ICallEventChatItem {
    return chatItem.type === ChatItemType.CallEvent;
  }

  static isCobrowsing(chatItem: IChatItem): chatItem is ICobrowsingEventChatItem {
    return chatItem.type === ChatItemType.CobrowsingEvent;
  }

  static isUserText(chatItem: IChatItem): chatItem is IUserTextChatItem {
    return chatItem.type === ChatItemType.UserText;
  }

  static isFakeUserText(chatItem: IChatItem): chatItem is IFakeUserTextChatItem {
    return chatItem.type === ChatItemType.FakeUserText;
  }

  static isNote(chatItem: IChatItem): chatItem is INoteChatItem {
    return chatItem.type === ChatItemType.Note;
  }

  static isStatusChange(chatItem: IChatItem): chatItem is IStatusChangeChatItem {
    return chatItem.type === ChatItemType.StatusChange;
  }

  static isDateSeparator(chatItem: IChatItem): chatItem is IDateSeparatorChatItem {
    return chatItem.type === ChatItemType.DateSeparator;
  }

  static isContactEnquiry(chatItem: IChatItem): chatItem is IContactEnquiryChatItem {
    return chatItem.type === ChatItemType.ContactEnquiry;
  }

  static isEmpty(chatItem: IChatItem): chatItem is IEmptyChatItem {
    return chatItem.type === ChatItemType.Empty;
  }

  static isCTAEvent(chatItem: IChatItem): chatItem is ICTAEventChatItem {
    return chatItem.type === ChatItemType.CTAEvent;
  }

  static isWidgetFormEvent(chatItem: IChatItem): chatItem is IWidgetFormEventChatItem {
    return chatItem.type === ChatItemType.WidgetFormEvent;
  }

  static isTagsChange(chatItem: IChatItem): chatItem is ITagsChangeChatItem {
    return chatItem.type === ChatItemType.TagsChange;
  }

  static isTopicsChange(chatItem: IChatItem): chatItem is ITopicsChangeChatItem {
    return chatItem.type === ChatItemType.TopicsChange;
  }

  static isRoomSummary(chatItem: IChatItem): chatItem is IRoomSummaryChatItem {
    return chatItem.type === ChatItemType.RoomSummary;
  }

  static isPredefinedMessageWidgetFormEvent(chatItem: IChatItem): chatItem is IWidgetFormEventChatItem {
    return ChatItemAssertion.isWidgetFormEvent(chatItem) && isPredefinedMessageConfigContext(chatItem.submission.widgetConfig);
  }
}
